export const EXTRA_CHARGE_TYPES = {
    Import: {
        "Border & Customs Related Charges": [
            "Export customs clearance",
            "Customs documentation & handling fee",
            "T1 / Transit document cost",
            "Guarantee / bond / customs deposit",
            "Customs inspection / red line handling",
            "X-ray / scanning fee",
            "Weighbridge fee",
            "Brokerage extra services",
        ],


        "Loading, Waiting & Operational Accessorials": [
            "Loading / unloading charges",
            "Forklift / crane / labor",
            "Waiting / detention",
            "Appointment / time-slot booking",
            "Yard / terminal entrance fee",
            "Re-positioning / extra pick-up",
            "Failed loading / truck return",
        ],

        "Route & Regulatory Surcharges": [
            "Toll / motorway / bridge fees",
            "Ro-Ro / ferry fees",
            "Permit / special route permissions",
            "Weekend / holiday driving restrictions cost",
            "Police escort / pilot car",
            "Low emission zone / city access fee",
        ],

        "Equipment, Cargo & Packaging Related": [
            "Pallet exchange / pallet cost",
            "Lashing / securing materials",
            "Dunnage / packing support",
            "Tarpaulin / straps / corner protectors",
            "ADR equipment requirements",
            "Temperature logger / reefer monitoring",
        ],

        "Risk, Incident & Financial Add-ons": [
            "Cargo insurance (All-risk / CMR)",
            "War risk / high-risk area surcharge",
            "Border queue stand-by",
            "Re-delivery / address change",
            "Storage / warehouse / cross-dock",
            "Bank charges / payment fees",
            "Currency difference / FX adjustment",
        ],
    },

    Export: {
        "Origin & Warehouse Charges": [
            "Pick-up / Pre-carriage (FTL/LTL)",
            "Waiting time / detention",
            "Warehouse handling (In / Out)",
            "Storage (warehouse)",
            "Palletizing / depalletizing",
            "Strapping / wrapping / packaging",
            "Weighing / measuring",
            "Forklift / crane / special equipment",
            "Rework / repacking / relabeling",
            "Stock count / inspection assistance",
        ],

        "Airline / Terminal / Handling Charges": [
            "Airline handling / THC",
            "X-ray / security screening",
            "Overweight / oversize handling",
            "Special cargo handling (DGR / VAL / AVI / PER / HUM)",
            "ULD build-up / breakdown",
            "Demurrage / terminal storage",
            "AWB amendment / correction",
            "No-show / cancellation",
            "Rebooking / rerouting",
            "Late acceptance / cut-off missed",
            "Weekend / after-hours handling",
            "Priority / express handling",
        ],

        "Documentation & Customs Related": [
            "Export customs clearance",
            "Customs examination / red line",
            "Bonded transfer / transit procedure",
            "Documentation fee",
            "AWB issuance (MAWB / HAWB)",
            "Manifest / ENS / security filing",
            "Certificate / chamber / attestation fees",
            "Notary / translation / courier",
        ],

        "Compliance, Risk & Insurance": [
            "Dangerous goods (DGR) fee",
            "Lithium battery compliance fee",
            "Security surcharge",
            "War risk / emergency surcharge",
            "Fuel surcharge (FSC)",
            "Cargo insurance",
            "High value cargo fee",
            "Temperature controlled handling (REEF / PHARMA)",
        ],

        "Destination / Exceptions (Prepaid at Origin)": [
            "Destination handling (DHC)",
            "On-forwarding / last mile delivery",
            "Remote area surcharge",
            "Return to shipper (RTO) / disposal",
            "Split shipment fee",
            "Address change / delivery appointment",
        ],
    },

    Domestic: {
        "Border & Customs Related Charges": [
            "Export customs clearance",
            "Customs documentation & handling fee",
            "T1 / Transit document cost",
            "Guarantee / bond / customs deposit",
            "Customs inspection / red line handling",
            "X-ray / scanning fee",
            "Weighbridge fee",
            "Brokerage extra services",
        ],

        "Loading, Waiting & Operational Accessorials": [
            "Loading / unloading charges",
            "Forklift / crane / labor",
            "Waiting / detention",
            "Appointment / time-slot booking",
            "Yard / terminal entrance fee",
            "Re-positioning / extra pick-up",
            "Failed loading / truck return",
        ],

        "Route & Regulatory Surcharges": [
            "Toll / motorway / bridge fees",
            "Ro-Ro / ferry fees",
            "Permit / special route permissions",
            "Weekend / holiday driving restrictions cost",
            "Police escort / pilot car",
            "Low emission zone / city access fee",
        ],

        "Equipment, Cargo & Packaging Related": [
            "Pallet exchange / pallet cost",
            "Lashing / securing materials",
            "Dunnage / packing support",
            "Tarpaulin / straps / corner protectors",
            "ADR equipment requirements",
            "Temperature logger / reefer monitoring",
        ],

        "Risk, Incident & Financial Add-ons": [
            "Cargo insurance (All-risk / CMR)",
            "War risk / high-risk area surcharge",
            "Border queue stand-by",
            "Re-delivery / address change",
            "Storage / warehouse / cross-dock",
            "Bank charges / payment fees",
            "Currency difference / FX adjustment",
        ],
    },

    Transit: {
        "Border & Customs Related Charges": [
            "Export customs clearance",
            "Customs documentation & handling fee",
            "T1 / Transit document cost",
            "Guarantee / bond / customs deposit",
            "Customs inspection / red line handling",
            "X-ray / scanning fee",
            "Weighbridge fee",
            "Brokerage extra services",
        ],

        "Loading, Waiting & Operational Accessorials": [
            "Loading / unloading charges",
            "Forklift / crane / labor",
            "Waiting / detention",
            "Appointment / time-slot booking",
            "Yard / terminal entrance fee",
            "Re-positioning / extra pick-up",
            "Failed loading / truck return",
        ],

        "Route & Regulatory Surcharges": [
            "Toll / motorway / bridge fees",
            "Ro-Ro / ferry fees",
            "Permit / special route permissions",
            "Weekend / holiday driving restrictions cost",
            "Police escort / pilot car",
            "Low emission zone / city access fee",
        ],

        "Equipment, Cargo & Packaging Related": [
            "Pallet exchange / pallet cost",
            "Lashing / securing materials",
            "Dunnage / packing support",
            "Tarpaulin / straps / corner protectors",
            "ADR equipment requirements",
            "Temperature logger / reefer monitoring",
        ],

        "Risk, Incident & Financial Add-ons": [
            "Cargo insurance (All-risk / CMR)",
            "War risk / high-risk area surcharge",
            "Border queue stand-by",
            "Re-delivery / address change",
            "Storage / warehouse / cross-dock",
            "Bank charges / payment fees",
            "Currency difference / FX adjustment",
        ],
    },
};
